export enum ContentApisActionTypes {
    CONTENT_API_RESPONSE_SUCCESS = 'CONTENT_API_RESPONSE_SUCCESS',
    CONTENT_API_RESPONSE_ERROR = 'CONTENT_API_RESPONSE_ERROR',
    GET_CONTENT_APIS_DATA = 'GET_CONTENT_API_DATA',
}
